import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Routers from "./Routers";

function App() {
  const location = useLocation();
  useEffect(() => {
    document.body.classList.add("home-one");
    return () => {
      document.body.classList.add("home-one");
    };
  }, [location.pathname]);
  return <Routers />;
}

export default App;
